/* Fornvegr bindrune preview engine — JS port of generate_bumerke.bindrune_mark.
 * Geometry contract: must match the Python production renderer exactly
 * (verified by qa_compare.py across all initial pairs). */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.FornvegrBindrune = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var LETTER_RUNES = {
    A: 'ᚨ', B: 'ᛒ', C: 'ᚲ', D: 'ᛞ', E: 'ᛖ', F: 'ᚠ', G: 'ᚷ', H: 'ᚺ',
    I: 'ᛁ', J: 'ᛃ', K: 'ᚲ', L: 'ᛚ', M: 'ᛗ', N: 'ᚾ', O: 'ᛟ', P: 'ᛈ',
    Q: 'ᚲᚹ', R: 'ᚱ', S: 'ᛊ', T: 'ᛏ', U: 'ᚢ', V: 'ᚹ', W: 'ᚹ', X: 'ᚲᛊ',
    Y: 'ᛁ', Z: 'ᛉ', 'Æ': 'ᛇ', 'Ø': 'ᛟ', 'Å': 'ᚨ', 'Þ': 'ᚦ', 'Ð': 'ᛞ',
    'Œ': 'ᛟᛖ', 'Ł': 'ᛚ'
  };

  var RUNE_BRANCHES = {
    'ᚠ': [[0, 0.16, 1, 0.03], [0, 0.34, 1, 0.21]],
    'ᚢ': [[0, 0.02, 1, 0.16], [1, 0.16, 1, 1.0]],
    'ᚦ': [[0, 0.30, 1, 0.50], [1, 0.50, 0, 0.70]],
    'ᚨ': [[0, 0.08, 1, 0.24], [0, 0.24, 1, 0.40]],
    'ᚱ': [[0, 0.06, 1, 0.20], [1, 0.20, 0, 0.36], [0, 0.36, 1, 0.60]],
    'ᚲ': [[0, 0.50, 1, 0.30], [0, 0.50, 1, 0.70]],
    'ᚷ': [[0, 0.30, 1, 0.12], [0, 0.30, 1, 0.48]],
    'ᚹ': [[0, 0.06, 1, 0.16], [1, 0.16, 0, 0.26]],
    'ᚺ': [[0, 0.40, 1, 0.56]],
    'ᚾ': [[0, 0.56, 1, 0.40]],
    'ᛁ': [],
    'ᛃ': [[0, 0.30, 1, 0.42], [0, 0.60, 1, 0.48]],
    'ᛈ': [[0, 0.24, 1, 0.18], [1, 0.18, 1, 0.58], [1, 0.58, 0, 0.52]],
    'ᛇ': [[0, 0.06, 1, 0.00]],
    'ᛉ': [[0, 0.14, 1, 0.00]],
    'ᛊ': [[0, 0.28, 1, 0.40], [1, 0.40, 0, 0.52], [0, 0.52, 1, 0.64]],
    'ᛏ': [[0, 0.04, 1, 0.18]],
    'ᛒ': [[0, 0.06, 1, 0.20], [1, 0.20, 0, 0.34], [0, 0.34, 1, 0.48], [1, 0.48, 0, 0.62]],
    'ᛖ': [[0, 0.06, 1, 0.20], [1, 0.20, 1, 1.0]],
    'ᛗ': [[1, 0.0, 1, 1.0], [0, 0.06, 1, 0.30], [1, 0.06, 0, 0.30]],
    'ᛚ': [[0, 0.06, 1, 0.24]],
    'ᛜ': [[0, 0.34, 1, 0.50], [1, 0.50, 0, 0.66]],
    'ᛟ': [[0, 0.24, 1, 0.44], [1, 0.44, 0, 0.62], [0, 0.62, 1, 0.80]],
    'ᛞ': [[0, 0.30, 1, 0.14], [0, 0.30, 1, 0.54], [1, 0.14, 1, 0.54]]
  };

  function baseLetter(ch) {
    var d = ch.normalize('NFD');
    for (var i = 0; i < d.length; i += 1) {
      if (!/[̀-ͯ]/.test(d.charAt(i))) return d.charAt(i);
    }
    return ch;
  }

  function initialRunes(initials) {
    var out = [];
    var up = initials.trim().normalize('NFC').toUpperCase();
    for (var i = 0; i < up.length; i += 1) {
      var ch = up.charAt(i);
      var rune = LETTER_RUNES[ch] || LETTER_RUNES[baseLetter(ch)];
      if (rune) out.push(rune.charAt(0));
      if (out.length === 2) break;
    }
    return out;
  }

  /* Mirrors Python bindrune_mark(initials, bx, by, bs, w).
   * Returns { segments: [[x1,y1,x2,y2],...], pin: [cx,cy,r], runes: [...] } */
  function bindruneGeometry(initials, bx, by, bs, w) {
    var runes = initialRunes(initials);
    if (!runes.length) runes = ['ᛁ'];
    if (runes.length === 1) runes = [runes[0], runes[0]];

    var cx = bx + bs / 2.0;
    var reach = bs * 0.30;
    var sided = [[1, runes[0]], [-1, runes[1]]];

    var nys = [];
    sided.forEach(function (sr) {
      (RUNE_BRANCHES[sr[1]] || []).forEach(function (b) {
        nys.push(b[1], b[3]);
      });
    });
    var nyLo = nys.length ? Math.min.apply(null, nys) : 0.0;
    var nyHi = nys.length ? Math.max.apply(null, nys) : 1.0;
    var pad = 0.05;
    nyLo -= pad;
    nyHi += pad;
    var span = Math.max(nyHi - nyLo, 0.25);

    var drawH = bs * 0.90;
    var cy = by + bs / 2.0;
    function Y(ny) {
      return cy + (ny - (nyLo + nyHi) / 2.0) * (drawH / span);
    }

    var segments = [[cx, Y(nyLo), cx, Y(nyHi)]];
    sided.forEach(function (sr) {
      var sign = sr[0];
      (RUNE_BRANCHES[sr[1]] || []).forEach(function (b) {
        segments.push([cx + sign * b[0] * reach, Y(b[1]),
                       cx + sign * b[2] * reach, Y(b[3])]);
      });
    });

    return { segments: segments, pin: [cx, Y(nyLo), w * 1.6], runes: runes };
  }

  function bindruneSVG(initials, opts) {
    opts = opts || {};
    var size = opts.size || 100;
    var ink = opts.ink || '#1B1A18';
    var bronze = opts.bronze || '#8A6A3B';
    var bg = opts.bg || 'none';
    var bs = size * 0.8;
    var b = size * 0.1;
    var w = size * 0.028;
    var g = bindruneGeometry(initials, b, b, bs, w);
    var parts = ['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + size + ' ' + size + '" role="img" aria-label="Bindrune preview">'];
    if (bg !== 'none') {
      parts.push('<rect x="0" y="0" width="' + size + '" height="' + size + '" fill="' + bg + '"/>');
    }
    g.segments.forEach(function (s) {
      parts.push('<line x1="' + s[0].toFixed(2) + '" y1="' + s[1].toFixed(2) +
                 '" x2="' + s[2].toFixed(2) + '" y2="' + s[3].toFixed(2) +
                 '" stroke="' + ink + '" stroke-width="' + w.toFixed(2) +
                 '" stroke-linecap="square"/>');
    });
    parts.push('<circle cx="' + g.pin[0].toFixed(2) + '" cy="' + g.pin[1].toFixed(2) +
               '" r="' + g.pin[2].toFixed(2) + '" fill="' + bronze + '"/>');
    parts.push('</svg>');
    return { svg: parts.join(''), runes: g.runes };
  }

  return {
    LETTER_RUNES: LETTER_RUNES,
    RUNE_BRANCHES: RUNE_BRANCHES,
    initialRunes: initialRunes,
    bindruneGeometry: bindruneGeometry,
    bindruneSVG: bindruneSVG
  };
});
